import { connect } from 'react-redux';
import Label from '../../components/handoff/Label';
import { getZoomScale } from '../../selectors/handoff';
function mapStateToProps(state) {
    var scale = getZoomScale(state);
    var img = state.screen.currentScreen.img;
    var renderedImageDimensions = {
        width: img.width * scale,
        height: img.height * scale,
    };
    return { renderedImageDimensions: renderedImageDimensions };
}
export default connect(mapStateToProps)(Label);
